export const CORPORATE = 'Corporate';
export const BU_DROPDOWN_TITLE = 'Select an Area of Specialization';
export const BU_ALL_OPTION = 'Corporate';
export const AUDIENCE_DROPDOWN_TITLE = 'Tell us A Little About Yourself';
